/* eslint-disable jsdoc/require-jsdoc */
import { AgentRegistryMembershipRole } from '@tryiris-ai/common.protojs/api/v1/agent_registry';

import type { User } from './types.js';

export const ReverseRoleTranslationMap: Record<User['permission'], AgentRegistryMembershipRole> = {
  admin: AgentRegistryMembershipRole.AGENT_REGISTRY_MEMBERSHIP_ROLE_ADMIN,
  producer: AgentRegistryMembershipRole.AGENT_REGISTRY_MEMBERSHIP_ROLE_PRODUCER,
  owner: AgentRegistryMembershipRole.AGENT_REGISTRY_MEMBERSHIP_ROLE_OWNER,
  viewer: AgentRegistryMembershipRole.AGENT_REGISTRY_MEMBERSHIP_ROLE_VIEWER
};

export const RoleTranslationMap: Record<AgentRegistryMembershipRole, User['permission']> = {
  [AgentRegistryMembershipRole.AGENT_REGISTRY_MEMBERSHIP_ROLE_ADMIN]: 'admin',
  [AgentRegistryMembershipRole.AGENT_REGISTRY_MEMBERSHIP_ROLE_PRODUCER]: 'producer',
  [AgentRegistryMembershipRole.AGENT_REGISTRY_MEMBERSHIP_ROLE_OWNER]: 'owner',
  [AgentRegistryMembershipRole.AGENT_REGISTRY_MEMBERSHIP_ROLE_VIEWER]: 'viewer',
  [AgentRegistryMembershipRole.AGENT_REGISTRY_MEMBERSHIP_ROLE_UNSPECIFIED]: 'viewer'
};
